import React from "react";
import "./style.css";

export const NavbarL = () => {
  return (
    <header className="header">
      <div className="left">
        <a href="/">
          <h3>UM</h3>
          <h4>Developer</h4>
        </a>
      </div>
    </header>
  );
};
